exports.components = {
  "component---src-pages-3-d-tsx": () => import("./../../../src/pages/3d.tsx" /* webpackChunkName: "component---src-pages-3-d-tsx" */),
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-secret-tsx": () => import("./../../../src/pages/secret.tsx" /* webpackChunkName: "component---src-pages-secret-tsx" */),
  "component---src-templates-portfolio-tsx": () => import("./../../../src/templates/portfolio.tsx" /* webpackChunkName: "component---src-templates-portfolio-tsx" */)
}

